import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from '@/_shared/services/axios-client';
import { BulkDownloadRequest } from '@/_shared/models/category-folders.models';

@injectable()
export class CategoryInsightDownloadsService {
  async download(request: BulkDownloadRequest): Promise<Blob> {
    const response = await axiosClient.post<Blob>(
      '/api/category-insights/download',
      request,
      {
        responseType: 'blob',
      }
    );

    return response.data;
  }
}
